export default __webpack_public_path__ + "static/media/jabar.cbb52de4.png";